import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function AppNav(props) {

    return (

        <Navbar bg="primary" variant="dark">
            <Container>
                <Navbar.Brand href="/form/v2/k845kdka">AEF info - Formulaires</Navbar.Brand>
                <Nav className="me-auto">
                    <Nav.Link href="/form/v2/k845kdka">Liste</Nav.Link>
                </Nav>
            </Container>
        </Navbar>
    );
}

export default AppNav;